module.exports = __webpack_public_path__ + "static/media/ChristianPippin-resume.cd595055.pdf";